import React from "react";
import ActionRouter from './Action/Router';
export { getFields } from './Action/Router';

export default function ActionPmRouter(props) {
    return (
        <ActionRouter {...props} mode='PM' />
    );
};
